
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import headers from './errorsHeaders';
import { EposErrorItem } from '@/interfaces/models/EposErrorItem';

@Component
export default class ErrorsTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: EposErrorItem[];
  @Prop({ type: Boolean, default: true }) public pagination!: boolean;

  public expanded: string[] = [];

  get tableHeaders() {
    return headers.map((h: ColumnHeader) => ({ ...h, text: this.$t(h.text) }));
  }
}
